import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Divider,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export type NotificationType = 'email' | 'push';

interface NotificationPlanProps {
  selectedOptions: NotificationType[];
  onChange: (options: NotificationType[]) => void;
  error?: string;
  disabled?: boolean;
}

const NotificationPlan: React.FC<NotificationPlanProps> = ({
  selectedOptions,
  onChange,
  error,
  disabled = false,
}) => {
  const { t } = useTranslation();
  
  const notificationOptions: { value: NotificationType; label: string; disabled?: boolean }[] = [
    { value: 'email', label: t('campaignExperimental.create.emailLabel') },
    { value: 'push', label: t('campaignExperimental.create.pushLabelDisabled'), disabled: true }
  ];

  const handleOptionChange = (option: NotificationType, checked: boolean) => {
    const optionConfig = notificationOptions.find((item) => item.value === option);
    if (optionConfig?.disabled) {
      return;
    }

    const newOptions = checked
      ? [...selectedOptions, option]
      : selectedOptions.filter(item => item !== option);
    onChange(newOptions);
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('campaignExperimental.create.notificationPlanTitle')}
        </Typography>
        <Divider sx={{ mb: 3 }} />
        
        <FormControl component="fieldset" error={!!error} disabled={disabled}>
          <FormGroup row sx={{ mt: 1 }}>
            {notificationOptions.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={selectedOptions.includes(option.value)}
                    onChange={(e) => handleOptionChange(option.value, e.target.checked)}
                    disabled={disabled || option.disabled}
                  />
                }
                disabled={disabled || option.disabled}
                label={option.label}
                sx={{ mr: 3 }}
              />
            ))}
          </FormGroup>
          {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
      </CardContent>
    </Card>
  );
};

export default NotificationPlan;
